module.exports = __webpack_public_path__ + "img/plus-icon.82341c11.svg";